import { Box, createStyles, Stack } from '@mantine/core';
import { isNil } from 'lodash-es';
import { DOCUMENTATION_WIDTH } from '../../../components/Documentation/constants';
import type { IInboxViewBodyProps } from '../types';
import { InboxViewContent } from './InboxViewContent';

const useStyles = createStyles(
	(theme, { isComment }: { isComment: boolean }) => ({
		scrollbarContainer: {
			display: 'flex',
			justifyContent: 'center',
			width: '100%',
			overflowY: 'auto',
		},
		container: {
			padding: isComment
				? `${theme.spacing['3xl']} ${theme.spacing['2xl']}`
				: `0 ${theme.spacing['5xl']}`,
			width: '100%',
		},
		content: {
			width: '100%',
			maxWidth: !isComment ? `${DOCUMENTATION_WIDTH}px` : '100%',
			margin: '0 auto',
			minHeight: '80vh',
			paddingBottom: theme.spacing['5xl'],
		},
	})
);

export function InboxViewBody({
	selected,
	isLoading,
	commentActions,
	handleDeleteKey,
	openEditKeyModal,
	completeAutomationReviewMutation,
	embeddedPrompt,
	isLoadingEmbeddedPrompt,
}: IInboxViewBodyProps) {
	const { classes } = useStyles({
		isComment: Boolean(
			selected?.computedMetadata.isComment &&
				!selected?.computedMetadata.isMonitorIncident
		),
	});

	if (isNil(selected) && !isLoading) {
		return null;
	}

	return (
		<Box className={classes.scrollbarContainer}>
			<Box className={classes.container}>
				<Stack className={classes.content} spacing="lg">
					<InboxViewContent
						selected={selected}
						commentActions={commentActions}
						handleDeleteKey={handleDeleteKey}
						openEditKeyModal={openEditKeyModal}
						completeAutomationReviewMutation={completeAutomationReviewMutation}
						embeddedPrompt={embeddedPrompt}
						isLoadingEmbeddedPrompt={isLoadingEmbeddedPrompt}
					/>
				</Stack>
			</Box>
		</Box>
	);
}
